import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { AbstractEmptyAlert } from "./AbstractEmptyAlert";

export class EmptyAlert extends AbstractEmptyAlert {
  constructor(object: IFormatObjectEditable) {
    super(object);
  }

  get kind(): string {
    return "名称警告";
  }
}
